import { render, staticRenderFns } from "./Localization.vue?vue&type=template&id=4be85c44&"
import script from "./Localization.vue?vue&type=script&lang=ts&"
export * from "./Localization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports